// extracted by mini-css-extract-plugin
export default {"player-number":"player-number--NZipNhrVSL","playerNumber":"player-number--NZipNhrVSL"};